import storage from "../../services/storage";
import initialState from "../initialState";
import {
  InitialState,
  SettingActions,
  TOGGLE_SETTINGS_OPTION,
  THEME_CHANGE,
} from "../types";

const settingsReducer = (
  state = initialState.settingsState,
  action: SettingActions
): InitialState["settingsState"] => {
  switch (action.type) {
    case THEME_CHANGE: {
      const newTheme = state.theme === "light" ? "dark" : "light";
      storage.set("theme", newTheme);
      return {
        ...state,
        theme: newTheme,
      };
    }
    case TOGGLE_SETTINGS_OPTION:
      return {
        ...state,
        [action.payload.key]: !state[action.payload.key],
      };
    default:
      return state;
  }
};

export default settingsReducer;
